export function postToIOSBridge(handler, message = handler) {
    window.webkit?.messageHandlers?.[handler]?.postMessage(message);
}
